import { ValidateField } from 'helpers/Validation';

export const TestResultSectionDataP73 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [
                {
                    key: 'F82HmiReadingAt',
                    label: 'HMI Reading after Test',
                    value: ValidateField(formData.F82HmiReadingAt),
                    isRequired: true,
                    xs: 4,
                    labelWidth: '50%',
                    type: 'number',
                    maxLength: '10',
                    width: '50%',
                    direction: 'rtl',
                    textAlign: 'center',
                    marginTop: '15px'
                },
                {
                    key: 'Nodata',
                    isLabel: true,
                    xs: 1,
                },
                {
                    key: 'F83ProcessGaugeReadingAtLabel',
                    label: 'Process Gauge Reading after Test',
                    labelWidth: '97.3%',
                    xs: 3,
                    height: '1.2rem',
                    padding: '20px 0 0 0',
                    isLabel: 'true',
                    textAlign: 'end',
                    fontSize: '9pt',
                    fontWeight: '600'
                },
                {
                    key: 'F83ProcessGaugeReadingAt',
                    value: ValidateField(formData.F83ProcessGaugeReadingAt),
                    isRequired: true,
                    xs: 4,
                    labelWidth: '0',
                    type: 'number',
                    maxLength: '10',
                    height: '1.2rem',
                    textAlign: 'center',
                    width: '100%',
                    marginTop: '15px',
                    marginLeft: '0.8px'
                }]
        }]

});
